import { ReactElement } from 'react'
import { Modal } from '../../../components'
import strings from '../../../locale/en'

interface CreateTestModalProps {
  handleCancel: () => void
  handleSubmit: () => void
}

const CreateSectionInit = ({
  handleCancel,
  handleSubmit
}: CreateTestModalProps): ReactElement => {
  const {
    menu: {
      admin: {
        createTest: { createSection, createSectionDescription }
      }
    },
    button: { createSectionText, skipSectionText }
  } = strings
  return (
    <Modal
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      title={createSection}
      description={createSectionDescription}
      submitButtonText={createSectionText}
      cancelButtonText={skipSectionText}
    ></Modal>
  )
}

export default CreateSectionInit
